import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { cesInfoData, techBlack, altLtGray } from '../../common/utils/constant';
import './ces.scss';
import InfoBox from './components/infoBox';
import ContentSection from './components/contentSection';
import { SectionWrapper } from '../../theme/layouts/MainLayout';
import ContactForm from '../insight/components/form';
import RelatedArticle from '../insight/components/relatedArticle';
import AppImage from '../../common/features/image';

const CES = () => {
  const [isMobile, setIsMobile] = useState(false);

  const handleResize = () => setIsMobile(window.innerWidth <= 480);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cesRelatedArticles = [
    {
      "links": [
        "/a-leading-electronics-brand-increased-sales-week-over-week-during-a-key-launch-period",
        "/pmg-delivered-content-to-holiday-electronics-shoppers-to-boost-pajama-sales-for-their-client",
        "/a-leading-headphones-brand-was-heard-loud-and-clear-using-mobile-ad-placements"
      ]
    }
  ]

  return (
    <div className='ces-wrapper'>

      <SectionWrapper bg={techBlack}>
        <section className="ces-section-1">
          <Row>
            <Col md={5} sm={12}>
              <div className='ces-banner'>
              <div className="ces-title-banner">We’re taking our innovations and partnerships to the next level.</div>
              <div className="ces-subtext-banner">In the coming year, Best Buy Ads is introducing new initiatives and experiences, expanding our partnerships and testing innovations to deliver next level solutions for your brand.</div>
              </div>
            </Col>
            <Col md={7} sm={12} className='ces-rightside-img'>
              <AppImage src={'/images/ces/CESPage_WhatsNews_Hero_DataAbstraction copy_2x.png'} alt='We’re taking our innovations and partnerships to the next level' title='We’re taking our innovations and partnerships to the next level' className='ces-banner-img' />
            </Col>
          </Row>
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <section className='ces-section-2'>
          <ContentSection
            titleText={'Self-Service'}
            text={'Working in tandem with new and existing partners, we are expanding our self-service offerings to help our brand and agency partners create campaigns and view reporting with streamlined solutions that put control right at your fingertips.'}
            imageSrc={'/images/ces/CESPage_WhatsNews_Self-Service_2x.png'}
            reverseOrder={true}
            imageClass="ces-rightside-img"

          />
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <section className='ces-section-3'>
          <ContentSection
            titleText={'Product Innovation'}
            text={'By elevating our in-store experiences, offering in-game content, customizing sponsored product ads and integrating the performance of Al in our partners campaigns, we are enhancing the products, solutions and insights that take brands to the next level.'}
            imageSrc={'/images/ces/CESPage_WhatsNews_Product Innovation_2x.png'}
            reverseOrder={isMobile ? true : false}
            imageClass="ces-leftside-img"
            linkTitle="Explore our solutions"
            ctalink="/solutions"
            linkColor="purple"
          />
        </section>
      </SectionWrapper>

      <SectionWrapper bg={techBlack}>
        <section className='ces-section-4'>
          <ContentSection
            titleText={'Custom Audiences'}
            text={'We are exploring ways to capture new audiences in the consumer electronics community. As the nation’s No. 1 consumer electronics retailer, we are uniquely suited to connect and deliver the right solutions to these audiences like no one else can.'}
            imageSrc={'/images/ces/CESPage_WhatsNews_Custom Audiences_2x.png'}
            reverseOrder={true}
            imageClass="ces-rightside-img"
            linkTitle="Learn more about our audiences"
            ctalink="/audience"
            linkColor="yellow"
          />
        </section>
      </SectionWrapper>

      <SectionWrapper bg={techBlack}>
        <section className='ces-section-5'>
          <ContentSection
            titleText={'Clean Room'}
            text={'By advancing our work with clean room capabilities, we can further our ability to share first-party data in a privacy-safe way and collaborate with your first-party data to build custom insights and audiences.'}
            imageSrc={'/images/ces/CESPage_WhatsNews_Clean Room_2x.png'}
            reverseOrder={isMobile ? true : false}
            imageClass="ces-leftside-img"  
          />
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <section className='ces-section-6'>
          <Row>
            {cesInfoData.map((info, index) => (
              <InfoBox key={index} title={info.title} text={info.text} />
            ))}
          </Row>
        </section>
      </SectionWrapper>

      <SectionWrapper bg={altLtGray}>
        <ContactForm/>
      </SectionWrapper>

      <SectionWrapper>
        <RelatedArticle relatedArticles={cesRelatedArticles[0]}/>
      </SectionWrapper>
    </div>
  )
}

export default CES;

